import { create } from 'evx'
import 'element-closest'
import Queue from './lib/Queue'
import Slider from './components/Slider'
import CountdownTimer from './components/CountdownTimer'
import SelectURL from './components/SelectURL'
import FreeGift from './components/FreeGift'
import CollectionLimit from './components/CollectionLimit'
import QuickView from './components/QuickView'

const components = {
  'slider': Slider,
  'countdown-timer': CountdownTimer,
  'select-url': SelectURL,
  'free-gift': FreeGift,
  'collection-limit': CollectionLimit,
  'quick-view': QuickView
}
 
const options = {
  turbolinks: false
}

const state = {
  eventQueue: new Queue(),
  ajaxCache: []
}

export default class Theme {
  constructor (ctx = state, passedOptions = {}) {
    this._options = {...passedOptions, ...options}
    let themeInfoElem = document.querySelector('[data-theme-information]')
    if (themeInfoElem) {
      ctx = {...JSON.parse(themeInfoElem.innerHTML), ...ctx}
    }
    this._ctx = create(ctx)
    this._components = []
    this._viewportEvent()
  }

  _viewportEvent () {
    window.addEventListener('resize', () => {
      this._viewportLogic()
    }, { passive: true })
    this._viewportLogic()
  }

  _viewportLogic () {
    let vh = window.innerHeight * 0.01;
    let vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }

  mountComponents (container = document) {
    for (let componentKey in components) {
      if (components.hasOwnProperty(componentKey)) {
        let selector = `[data-${componentKey}]`
        let elements = container.querySelectorAll(selector)
        for (let elem of elements) {
          let optionStr = elem.getAttribute(`data-${componentKey}`).trim()
          let options = {}
          if (optionStr.startsWith('{') || optionStr.startsWith('[')) {
            options = JSON.parse(optionStr)
          }
          let compInstance = new components[componentKey](elem, this, options, this._ctx)
          this._components.push({
            type: componentKey,
            elem: elem,
            id: compInstance._options.id,
            component: compInstance
          })
          compInstance.mount()
        }
      }
    }
    window.__Theme = this
    window.__ThemeComponents = this._components

    this._ctx.emit('ffc--mounted')
  }

  unmountComponents (container = document) {
    let componentsInContainer = this._components.filter(comp => container.contains(comp.elem))
    for (let component of componentsInContainer) {
      let componentObj = component.component
      if (typeof componentObj.unmount === 'function') {
        componentObj.unmount()
      }
    }
  }

  getOptions () {
    return this._options
  }

  getComponent (id) {
    return this._components.filter(component => component.id === id)[0]
  }
}